import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Twofiveseaterbusonrentinshirdi() {



    const cardData = {





keyword: "25 Seater Bus on Rent in Shirdi",

headingDescription: "Sai Shirdi Cab provides 25 Seater Bus on Rent in Shirdi for pilgrimage groups, families, corporate teams, school groups, tour groups, event travelers, and organizations planning comfortable group journeys from Shirdi to outstation destinations. A 25-seater bus is a practical choice when a larger group wants to travel together in one vehicle instead of arranging multiple cars or smaller vehicles. Customers can hire the bus with an experienced driver for one-way journeys, round trips, multi-day tours, pilgrimage trips, family vacations, corporate outings, sightseeing tours, and customized group itineraries. From Shirdi, groups can plan journeys to destinations such as Bhandardara, Saputara, Igatpuri, Shani Shingnapur, Bhimashankar, Saptashrungi, Trimbakeshwar, Mahabaleshwar, Ajanta-Ellora, and Goa. Sai Shirdi Cab offers clean and well-maintained buses, comfortable seating, experienced drivers, flexible pickup timings, and convenient transportation for organized groups traveling together.",

topPlaces: [
{
title: "Bhandardara",
description: "Bhandardara is a scenic outstation destination from Shirdi that is suitable for family tours, group outings, corporate trips, and weekend travel. A 25-seater bus allows larger groups to travel together comfortably while carrying their luggage. The journey can be arranged as a round trip or multi-day sightseeing tour."
},
{
title: "Saputara",
description: "Saputara is a popular hill station suitable for group holidays, family tours, corporate outings, and leisure trips from Shirdi. Groups can hire a 25-seater bus for convenient transportation throughout the journey. Multi-day bookings can include sightseeing, hotel transfers, and return travel."
},
{
title: "Igatpuri",
description: "Igatpuri is a popular hill destination that can be covered from Shirdi by a private group bus. A 25-seater vehicle is suitable for families, tour groups, and corporate teams traveling together. Customers can plan a round trip with flexible sightseeing stops and convenient return transportation."
},
{
title: "Shani Shingnapur",
description: "Shani Shingnapur is an important pilgrimage destination from Shirdi and is frequently visited by devotees and organized groups. A 25-seater bus provides convenient transportation for larger pilgrimage groups traveling together. Customers can arrange a round trip with flexible temple visit timings."
},
{
title: "Bhimashankar",
description: "Bhimashankar is a prominent pilgrimage destination that can be included in a group tour from Shirdi. A 25-seater bus is suitable for devotees, families, and organized tour groups who prefer to travel together. The itinerary can include temple visits and additional sightseeing according to the group's requirements."
},
{
title: "Saptashrungi",
description: "Saptashrungi Devi Temple at Vani is a popular religious destination for group travel from Shirdi. Customers can hire a 25-seater bus for comfortable transportation of devotees and families. The journey can be combined with Nashik and other nearby pilgrimage destinations for a customized group tour."
},
{
title: "Trimbakeshwar",
description: "Trimbakeshwar is an important Jyotirlinga destination that can be covered from Shirdi as part of a pilgrimage tour. A 25-seater bus is convenient for larger groups traveling together, with planned pickup, temple visits, and return transportation. Customers can also combine Trimbakeshwar with Nashik."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is a popular hill station for family vacations, group holidays, corporate outings, and sightseeing trips from Shirdi. A 25-seater bus provides a convenient group travel solution for passengers who want to stay together throughout the journey. Multi-day rental can be arranged for sightseeing and hotel transfers."
},
{
title: "Ajanta-Ellora Caves",
description: "Ajanta and Ellora Caves are major heritage attractions suitable for organized group tours from Shirdi. A 25-seater bus provides comfortable transportation for families, school groups, and tour groups traveling together. Customers can plan a full-day or multi-day sightseeing itinerary with convenient stops."
},
{
title: "Goa",
description: "Goa is a popular long-distance holiday destination from Shirdi for families, corporate groups, tour groups, and leisure travelers. A 25-seater bus is suitable for larger groups planning an extended trip together. Customers can arrange multi-day transportation with hotel transfers, sightseeing, and return travel."
}
],










"services": [
{
"name": "25 Seater Bus on Rent in Shirdi",
"description": "25 Seater Bus on Rent in Shirdi provides spacious group transportation for families, tourist groups, organizations, and travelers. The bus can be arranged for local sightseeing, pilgrimage trips, outstation journeys, airport transfers, events, and customized group travel requirements."
},
{
"name": "25 Seater Bus Rental Shirdi",
"description": "25 Seater Bus Rental Shirdi offers a convenient transportation option for groups requiring additional seating capacity. Rental arrangements can be planned according to travel duration, passenger count, luggage requirements, pickup location, destination, and one-way or round-trip travel needs."
},
{
"name": "25 Seater Bus Hire Shirdi",
"description": "25 Seater Bus Hire Shirdi provides private group transportation for planned journeys from Shirdi. The bus can be hired for family outings, tourist tours, weddings, corporate trips, school travel, pilgrimage journeys, events, and outstation transportation."
},
{
"name": "25 Seater Tourist Bus Shirdi",
"description": "25 Seater Tourist Bus Shirdi provides comfortable group transportation for sightseeing and holiday trips. The vehicle can be arranged for Shirdi sightseeing, nearby destinations, multi-day tours, pilgrimage routes, family travel, and customized tourist itineraries."
},
{
"name": "25 Seater Bus Booking Shirdi",
"description": "25 Seater Bus Booking Shirdi allows groups to reserve suitable transportation in advance for their planned journey. Customers can provide travel dates, pickup timing, passenger count, luggage requirements, destination, journey duration, and preferred trip type."
},
{
"name": "25 Seater Bus With Driver Shirdi",
"description": "25 Seater Bus With Driver Shirdi provides chauffeur-driven transportation for groups seeking convenient private travel. The bus can be arranged for sightseeing, pilgrimage tours, weddings, corporate outings, school trips, events, airport transfers, and outstation journeys."
},
{
"name": "25 Seater Bus for Outstation Shirdi",
"description": "25 Seater Bus for Outstation Shirdi is suitable for groups planning long-distance travel from Shirdi to other cities and destinations. The journey can be organized according to the route, travel duration, passenger requirements, luggage, pickup location, and selected itinerary."
},
{
"name": "25 Seater Bus for Family Trip Shirdi",
"description": "25 Seater Bus for Family Trip Shirdi offers spacious transportation for extended families and larger groups traveling together. The bus can be arranged for holidays, pilgrimage visits, sightseeing tours, family functions, multi-day trips, and intercity travel from Shirdi."
},
{
"name": "25 Seater Bus for Wedding Shirdi",
"description": "25 Seater Bus for Wedding Shirdi provides group transportation for wedding guests, relatives, and family members. The bus can be arranged for hotel transfers, wedding venues, railway station pickups, guest movement, local transportation, and travel between different wedding functions."
},
{
"name": "25 Seater Bus for Corporate Trip Shirdi",
"description": "25 Seater Bus for Corporate Trip Shirdi provides group transportation for employees, business teams, and corporate travelers. It can be arranged for company outings, conferences, meetings, team activities, airport transfers, intercity travel, and planned corporate itineraries."
},
{
"name": "25 Seater Bus for School Trip Shirdi",
"description": "25 Seater Bus for School Trip Shirdi offers group transportation for students, teachers, and school staff traveling for educational or recreational trips. The bus can be arranged for sightseeing, educational visits, local excursions, pilgrimage travel, and planned outstation school journeys."
},
{
"name": "25 Seater Bus for Pilgrimage Shirdi",
"description": "25 Seater Bus for Pilgrimage Shirdi provides spacious transportation for groups of devotees visiting Shirdi and other religious destinations. The bus can be planned for Sai Baba darshan, temple tours, multi-destination pilgrimage routes, family groups, and customized religious travel schedules."
},
{
"name": "25 Seater Bus for Events Shirdi",
"description": "25 Seater Bus for Events Shirdi provides convenient group transportation for guests and participants attending different events. The bus can be arranged for conferences, exhibitions, functions, parties, social gatherings, corporate events, and transportation between hotels and event venues."
},
{
"name": "25 Seater AC Bus Shirdi",
"description": "25 Seater AC Bus Shirdi provides a comfortable group travel option for passengers looking for air-conditioned transportation. The bus can be arranged for family trips, sightseeing, pilgrimage journeys, corporate travel, weddings, school trips, events, and outstation routes."
},
{
"name": "25 Seater Luxury Bus Shirdi",
"description": "25 Seater Luxury Bus Shirdi offers a premium group transportation option for travelers seeking enhanced comfort during their journey. It can be arranged for weddings, corporate trips, family tours, special events, sightseeing, pilgrimage travel, and longer intercity journeys."
},
{
"name": "25 Seater Bus One Way Shirdi",
"description": "25 Seater Bus One Way Shirdi provides direct group transportation for passengers who require a single journey without arranging a return trip. The bus can be scheduled from the preferred pickup point in Shirdi to the selected destination according to travel date and group requirements."
},
{
"name": "25 Seater Bus Round Trip Shirdi",
"description": "25 Seater Bus Round Trip Shirdi is suitable for groups planning an onward journey and return to Shirdi. The trip can be organized according to travel dates, stay duration, passenger count, luggage, waiting requirements, destinations, and preferred return schedule."
},
{
"name": "25 Seater Bus Airport Transfer Shirdi",
"description": "25 Seater Bus Airport Transfer Shirdi provides spacious group transportation for airport pickup and drop requirements. The service can be coordinated with flight timings and arranged according to passenger count, luggage, airport location, pickup schedule, and final destination."
},
{
"name": "Affordable 25 Seater Bus Rental Shirdi",
"description": "Affordable 25 Seater Bus Rental Shirdi provides a practical group transportation option for travelers looking for spacious travel while managing their planned budget. Rental arrangements can be selected according to journey distance, passenger count, luggage, travel duration, route, and trip requirements."
},
{
"name": "Best 25 Seater Bus Hire Shirdi",
"description": "Best 25 Seater Bus Hire Shirdi provides spacious private transportation for families, tourist groups, corporate teams, wedding guests, school groups, and pilgrimage travelers. The bus can be hired for local travel, sightseeing, events, airport transfers, and customized outstation itineraries."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides 25 Seater Bus and other suitable group vehicles for transportation from Shirdi. Vehicles can be arranged for family trips, pilgrimage tours, weddings, corporate outings, school trips, sightseeing, events, airport transfers, and outstation journeys according to group requirements."
}
],
"tableData": [
["25 Seater Bus on Rent in Shirdi", "25 Seater Bus Rental Shirdi"],
["25 Seater Bus Hire Shirdi", "25 Seater Tourist Bus Shirdi"],
["25 Seater Bus Booking Shirdi", "25 Seater Bus With Driver Shirdi"],
["25 Seater Bus for Outstation Shirdi", "25 Seater Bus for Family Trip Shirdi"],
["25 Seater Bus for Wedding Shirdi", "25 Seater Bus for Corporate Trip Shirdi"],
["25 Seater Bus for School Trip Shirdi", "25 Seater Bus for Pilgrimage Shirdi"],
["25 Seater Bus for Events Shirdi", "25 Seater AC Bus Shirdi"],
["25 Seater Luxury Bus Shirdi", "25 Seater Bus One Way Shirdi"],
["25 Seater Bus Round Trip Shirdi", "25 Seater Bus Airport Transfer Shirdi"],
["Affordable 25 Seater Bus Rental Shirdi", "Best 25 Seater Bus Hire Shirdi"],
["Sai Shirdi Cabs", "25 Seater Bus on Rent in Shirdi"]
]
,







    whychoose: [
        { 
            WhyChooseheading: "25 Seater Bus on Rent in Shirdi for Group Travel", 
            WhyChoosedescription: "Sai Shirdi Cabs provides 25 Seater Bus rental services in Shirdi for pilgrimage groups, school and college groups, corporate teams, families, tourists, wedding guests, and other large groups. A 25 seater bus can be arranged for Sai Baba Darshan, Shirdi sightseeing, religious tours, events, airport and railway station transfers, outstation trips, and multi-day group journeys." 
        }, 
        { 
            WhyChooseheading: "Comfortable Transportation for Large Groups", 
            WhyChoosedescription: "A 25 Seater Bus is a practical transportation option for groups that need to travel together in one vehicle. It helps simplify group movement between hotels, temples, event venues, railway stations, airports, and sightseeing destinations while accommodating passengers and their travel luggage." 
        }, 
        { 
            WhyChooseheading: "25 Seater Bus for Sai Baba Darshan", 
            WhyChoosedescription: "Pilgrimage groups visiting Shirdi can rent a 25 Seater Bus for Sai Baba Darshan and travel to nearby religious destinations. Group transportation can be planned around temple visits, hotel stays, sightseeing schedules, and other activities included in the pilgrimage itinerary." 
        }, 
        { 
            WhyChooseheading: "Bus Rental for Shirdi Sightseeing", 
            WhyChoosedescription: "Tour groups can explore Shirdi and nearby attractions using a private 25 Seater Bus. Multiple sightseeing stops can be included according to the group's itinerary, travel duration, preferred destinations, and planned departure and return timings." 
        }, 
        { 
            WhyChooseheading: "Airport & Railway Station Group Transfers", 
            WhyChoosedescription: "A 25 Seater Bus can be arranged for group pickup and drop services from nearby airports and railway stations to hotels, temples, event venues, and other locations in Shirdi. This can make group transportation easier when several passengers arrive or depart together." 
        }, 
        { 
            WhyChooseheading: "Bus Hire for Weddings & Events", 
            WhyChoosedescription: "Families and event organizers can book a 25 Seater Bus for wedding guests, receptions, religious functions, corporate events, conferences, parties, and other gatherings in Shirdi. Transportation can be planned between guest accommodations, venues, railway stations, and other locations." 
        }, 
        { 
            WhyChooseheading: "Outstation & Multi-Day Bus Tours", 
            WhyChoosedescription: "The 25 Seater Bus can be considered for outstation group tours from Shirdi to destinations such as Nashik, Mumbai, Pune, Aurangabad, Trimbakeshwar, Shani Shingnapur, and other tourist or pilgrimage locations. Multi-day group trips can also be planned according to the required itinerary." 
        }, 
        { 
            WhyChooseheading: "Book 25 Seater Bus on Rent in Shirdi with Sai Shirdi Cabs", 
            WhyChoosedescription: "Share your pickup location, destination, travel date, group size, luggage requirements, rental duration, sightseeing or event plans, one-way or round-trip requirement, and travel schedule with Sai Shirdi Cabs to arrange a suitable 25 Seater Bus for your group." 
        } 
    ] 

}; 

const faqData = [ 
    { 
        question: "Can I rent a 25 Seater Bus in Shirdi?", 
        answer: "Yes, Sai Shirdi Cabs provides 25 Seater Bus rental services in Shirdi for pilgrimage groups, tourists, families, corporate teams, wedding guests, and other large groups." 
    }, 
    { 
        question: "Is a 25 Seater Bus suitable for Sai Baba Darshan?", 
        answer: "Yes, a 25 Seater Bus can be arranged for groups travelling to Sai Baba Temple and nearby pilgrimage destinations according to their planned itinerary." 
    }, 
    { 
        question: "Can I book a 25 Seater Bus for Shirdi sightseeing?", 
        answer: "Yes, groups can book a private 25 Seater Bus for Shirdi sightseeing and nearby attractions according to their preferred travel schedule and sightseeing plan." 
    }, 
    { 
        question: "Can I book a 25 Seater Bus for airport transfers?", 
        answer: "Yes, a 25 Seater Bus can be arranged for group airport pickup and drop services according to flight schedules and passenger requirements." 
    }, 
    { 
        question: "Can I book a 25 Seater Bus from Shirdi Railway Station?", 
        answer: "Yes, group railway station pickup and drop services can be arranged with a 25 Seater Bus according to the train schedule and group travel requirements." 
    }, 
    { 
        question: "Can I rent a 25 Seater Bus for a wedding in Shirdi?", 
        answer: "Yes, a 25 Seater Bus can be booked for wedding guests, family members, receptions, religious functions, and other event transportation requirements in Shirdi." 
    }, 
    { 
        question: "Can I use a 25 Seater Bus for outstation travel?", 
        answer: "Yes, the bus can be booked for outstation group journeys from Shirdi to various cities, tourist destinations, and pilgrimage locations according to your travel plans." 
    }, 
    { 
        question: "Can I rent a 25 Seater Bus for multiple days?", 
        answer: "Yes, multi-day bus rental arrangements can be discussed for extended pilgrimage tours, sightseeing trips, group vacations, corporate tours, and multi-city journeys." 
    }, 
    { 
        question: "Can a 25 Seater Bus be used for corporate group travel?", 
        answer: "Yes, businesses can consider a 25 Seater Bus for employee transportation, corporate events, conferences, meetings, group outings, and official tours depending on the group size and itinerary." 
    }, 
    { 
        question: "How can I book a 25 Seater Bus on Rent in Shirdi?", 
        answer: "Share your pickup point, destination, travel date, group size, luggage details, rental duration, sightseeing or event requirements, and one-way or return preference with Sai Shirdi Cabs to proceed with the booking." 
    } 
]; 

const testimonials = [ 
    { 
        id: 1, 
        name: "Mr. Vinod Jadhav", 
        feedback: "Our group rented a 25 Seater Bus in Shirdi for Sai Baba Darshan and nearby sightseeing. Travelling together in one vehicle made it much easier to coordinate our group throughout the trip.", 
        rating: 5 
    }, 
    { 
        id: 2, 
        name: "Mrs. Meena Patil", 
        feedback: "We arranged a 25 Seater Bus for a family event in Shirdi with guests coming from different locations. Having group transportation made hotel and venue transfers more convenient to manage.", 
        rating: 5 
    } 
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "25 Seater Bus on Rent in Shirdi",
  "image": "https://www.saishirdicabs.com/assets/images/25-seater-bus-on-rent-in-shirdi.webp",
  "description":
    "Book a 25 Seater Bus on Rent in Shirdi with Sai Shirdi Cabs for comfortable, spacious, and reliable group transportation. Our 25 Seater Bus is suitable for Sai Baba Darshan, Shirdi sightseeing, family trips, group tours, pilgrimages, weddings, corporate trips, school trips, airport transfers, railway station transfers, and outstation travel. Get a well-maintained bus with a professional driver, convenient pickup and drop locations, affordable rental service, and easy booking assistance.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/25-seater-bus-on-rent-in-shirdi"
  }
};






    return (
        <div>

<Helmet>
  <title>25 Seater Bus on Rent in Shirdi | 25 Seater Bus Rental | +91 7776814559</title>

  <meta
    name="description"
    content="Book a 25 Seater Bus on Rent in Shirdi with Sai Shirdi Cabs for group travel, Sai Baba Darshan, sightseeing, weddings, corporate trips, school trips and outstation journeys. Get a spacious bus with professional driver and easy booking."
  />

  <meta
    name="keywords"
    content="25 Seater Bus on Rent in Shirdi, 25 Seater Bus Rental Shirdi, 25 Seater Bus Hire Shirdi, 25 Seater Tourist Bus Shirdi, 25 Seater Bus Booking Shirdi, 25 Seater Bus with Driver Shirdi, 25 Seater Bus for Outstation Shirdi, 25 Seater Bus for Family Trip Shirdi, 25 Seater Bus for Wedding Shirdi, 25 Seater Bus for Corporate Trip Shirdi, 25 Seater Bus for School Trip Shirdi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/86.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Twofiveseaterbusonrentinshirdi;